// --------------------------------------
// #region  Loading
export var LOADING = 'LOADING';
// #endregion
export var PAGE_TYPE = 'PAGE_TYPE';
export var PageTypeEnum;
(function (PageTypeEnum) {
    PageTypeEnum["home"] = "home";
    PageTypeEnum["edit"] = "edit";
    PageTypeEnum["add"] = "add";
    PageTypeEnum["detail"] = "detail";
})(PageTypeEnum || (PageTypeEnum = {}));
export var RESET_KEY = 'RESET_KEY';
export var ANNOUNCEMENTS = 'ANNOUNCEMENTS';
